import { Component, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GalleryVM } from '../gallary/gallary.service';

@Component({
  selector: 'app-imagegrid',
  templateUrl: './imagegrid.component.html',
  styleUrls: ['./imagegrid.component.css']
})
export class ImagegridComponent {
  @Input()
  gallery_col1 = new BehaviorSubject<GalleryVM[]>([]);

  @Input()
  gallery_col2 = new BehaviorSubject<GalleryVM[]>([]);

  @Input()
  gallery_col3 = new BehaviorSubject<GalleryVM[]>([]);

  @Input()
  gallery_col4 = new BehaviorSubject<GalleryVM[]>([]);
}
